import React from "react"
import LoadingAnimation from "@kit/design/loading-animation"

export function Loading() {
  return (
    <div
      style={{ height: "532px" }}
      className="flex items-center justify-center"
    >
      <LoadingAnimation />
    </div>
  )
}
